import { JSX, Suspense } from "react";

import { MainHero } from "@/components/main/MainHero";
import MainList from "@/components/main/MainList.tsx";

const MainPage = (): JSX.Element => {
  return (
    <>
      <Suspense
        fallback={
          <div className="mt-6 aspect-[1880/764] animate-pulse rounded-[1.875rem] bg-surface-container-high  max-xl:mt-4 max-lg:mx-4"></div>
        }
      >
        <MainHero />
      </Suspense>
      <div className={"mt-8"}>
        <MainList />
      </div>
    </>
  );
};

export default MainPage;
